import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAccountSlug } from './use-account-slug';
import { useNavigationPaths } from './use-navigation-paths';

/**
 * Returns a function that navigates back to the previous page if the user
 * arrived from within Source, otherwise falls back to the dashboard.
 *
 * Use this whenever exiting a form or flow — it prevents navigating the user
 * out of Source when they deep-linked or opened the page in a new tab.
 */
export function useSafeBackNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const accountSlug = useAccountSlug();
  const { dashboardPath } = useNavigationPaths();

  return useCallback(() => {
    const { referrer } = document;
    const isFromSource =
      referrer &&
      referrer.startsWith(window.location.origin) &&
      new URL(referrer).pathname.includes(`/${accountSlug}/`);

    if (isFromSource || location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(dashboardPath);
    }
  }, [accountSlug, dashboardPath, location.key, navigate]);
}
